import { useState, createContext } from 'react'
import { toast } from 'react-toastify'

import { useLoading } from '@/hooks/useLoading'
import { managementAnalysisService } from '@/services/ManagementAnalysis'
import { utilityService } from '@/services/Parametrization/utilityService'

import { CONSTANTS } from '@/utils/CONSTANTS'

interface ManagementAnalysisProviderProps {
  children: React.ReactNode
}

type ManagementAnalysisData = {
  DATA: any
  GET_DATA: (params?: any, isFilterApplied?: boolean) => Promise<void>
  GET_ALL: (params?: any) => Promise<void>
  GET_SELECTS: () => Promise<any>
}

export const ManagementAnalysisContext = createContext(
  {} as ManagementAnalysisData
)

export function ManagementAnalysisProvider({
  children
}: ManagementAnalysisProviderProps) {
  const [DATA, SET_DATA] = useState({})
  const { SET_LOADING } = useLoading()

  const GET_DATA = async (params?: any, isFilterApplied?: boolean) => {
    try {
      SET_LOADING(true)
      const res: any = await managementAnalysisService.get(params)
      const managementAnalysis = res.data.data

      if (!managementAnalysis?.rows?.length)
        toast.warning(CONSTANTS.filter.empty)
      if (managementAnalysis?.rows?.length && isFilterApplied)
        toast.success(CONSTANTS.filter.success)

      SET_DATA((prevState) => ({
        ...prevState,
        managementData: managementAnalysis
      }))
    } catch (e: any) {
      toast.error(e.message)
    } finally {
      SET_LOADING(false)
    }
  }

  const GET_SELECTS = async () => {
    try {
      const [board, cr, model, category]: any = await Promise.all([
        utilityService.getDirectorship(),
        utilityService.getCR(),
        utilityService.getModel({ ativo: true }),
        utilityService.getModelCategory()
      ])

      const selectsData = {
        boardList: board.data.data,
        crList: cr.data.data,
        modelList: model.data.data,
        categoryList: category.data.data
      }
      SET_DATA((prevState) => ({ ...prevState, selectsData }))
      return selectsData
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  const GET_ALL = async (params?: any) => {
    try {
      SET_LOADING(true)
      const [managementData, selectsData]: any = await Promise.all([
        managementAnalysisService.get(params),
        GET_SELECTS()
      ])
      SET_DATA({ managementData: managementData.data.data, selectsData })
    } catch (e: any) {
      toast.error(e.message)
    } finally {
      SET_LOADING(false)
    }
  }

  return (
    <ManagementAnalysisContext.Provider
      value={{
        DATA,
        GET_DATA,
        GET_ALL,
        GET_SELECTS,
      }}
    >
      {children}
    </ManagementAnalysisContext.Provider>
  )
}
